import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { credentialsAPI } from '../services/api.js';
import axios from 'axios';
import './ClientCredentialsModal.css';

// const API_BASE_URL = process.env.REACT_APP_API_URL;
const API_BASE_URL = "https://quickpost.webzgrowth.in";
// const API_BASE_URL ='https://felisa-masked-fast.ngrok-free.dev';


const ClientCredentialsModal = ({ client, onClose }) => {
  const { token } = useAuth();
  
  const [credentials, setCredentials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [connectingPlatform, setConnectingPlatform] = useState(null);

  const platforms = [
    // {
    //   id: 'instagram',
    //   name: 'Instagram',
    //   icon: '📸',
    //   type: 'oauth_auto',  // ✅ CHANGED: Was 'access_token', now 'oauth_auto'
    //   fields: [],  // ✅ CHANGED: Empty array (no manual fields)
    //   color: '#E4405F'
    // },
    {
      id: 'facebook',
      name: 'Facebook with Instagram',
      icon: '📘',
      type: 'oauth_auto',  // ✅ CHANGED: Was 'access_token', now 'oauth_auto'
      fields: [],  // ✅ CHANGED: Empty array (no manual fields)
      color: '#1877F2'
    },
    {
      id: 'youtube',
      name: 'YouTube',
      icon: '▶️',
      color: '#ff0000',
      type: 'oauth_auto',  // ✅ ADD THIS LINE
      fields: []  // ✅ CHANGE: Empty array (no manual fields)
    },
    {
      id: 'linkedin',
      name: 'LinkedIn',
      icon: '💼',
      fields: [],
      type: 'oauth_auto',
      color: '#0A66C2'
    }
  ];

  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (client && token) {
      fetchCredentials();
    }
  }, [client, token]);

  const fetchCredentials = async () => {
    try {
      setLoading(true);
      const response = await credentialsAPI.getMyCredentials(token, client.id);
      if (response.success) {
        setCredentials(response.credentials);
      }
    } catch (err) {
      console.error('Error fetching credentials:', err);
    } finally {
      setLoading(false);
    }
  };

  const isConnected = (platformId) => {
    return credentials.some(cred => cred.platform === platformId && cred.is_connected);
  };

  const getCredential = (platformId) => {
    return credentials.find(cred => cred.platform === platformId);
  };

  const handleInputChange = (platformId, fieldName, value) => {
    setFormData(prev => ({
      ...prev,
      [platformId]: {
        ...prev[platformId],
        [fieldName]: value
      }
    }));
  };


  // ✅ NEW: Automatic Facebook/Instagram OAuth
    const handleFacebookAuthorizeAuto = async (platform) => {
    setConnectingPlatform(platform.id);

    try {
      console.log('🚀 Starting Facebook OAuth for client:', client.client_name);

      // Get OAuth URL from backend
      const response = await axios.post(
        `${API_BASE_URL}/api/oauth-auto/facebook/start`,
        { client_id: client.id },  // ✅ Pass client ID
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (!response.data.success) {
        alert('Failed to start Facebook authorization');
        setConnectingPlatform(null);
        return;
      }

      console.log('✅ OAuth URL received, opening popup...');

      // Open popup
      const width = 600;
      const height = 700;
      const left = (window.screen.width / 2) - (width / 2);
      const top = (window.screen.height / 2) - (height / 2);

      const popup = window.open(
        response.data.authUrl,
        'Facebook Authorization',
        `width=${width},height=${height},left=${left},top=${top}`
      );

      if (!popup) {
        alert('Popup blocked! Please allow popups for this site.');
        setConnectingPlatform(null);
        return;
      }

      // Listen for success
      const messageHandler = (event) => {
        if (event.data.type === 'facebook-oauth-success') {
          console.log('✅ Facebook connected:', event.data.pageName);
          
          const message = event.data.instagramAccountId 
            ? `✅ Connected: ${event.data.pageName} for ${client.client_name}\n✅ Instagram also connected!`
            : `✅ Connected: ${event.data.pageName} for ${client.client_name}`;
          
          window.removeEventListener('message', messageHandler);
          setConnectingPlatform(null);
          
          alert(message);
          fetchCredentials();
          
        } else if (event.data.type === 'facebook-oauth-error') {
          console.error('❌ OAuth error:', event.data.error);
          
          window.removeEventListener('message', messageHandler);
          setConnectingPlatform(null);
          
          alert(`❌ Connection failed: ${event.data.error}`);
        }
      };

      window.addEventListener('message', messageHandler);

      // Monitor popup
      const checkPopup = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkPopup);
          window.removeEventListener('message', messageHandler);
          setConnectingPlatform(null);
        }
      }, 1000);

    } catch (error) {
      console.error('❌ Error:', error);
      alert(`Failed to start authorization: ${error.message}`);
      setConnectingPlatform(null);
    }
  };

  const handleConnect = async (platform) => {
    const platformData = formData[platform.id] || {};
    
    // Validate all required fields are filled
    const missingFields = platform.fields.filter(field => !platformData[field.name]);
    if (missingFields.length > 0) {
      alert(`Please enter: ${missingFields.map(f => f.label).join(', ')}`);
      return;
    }

    setConnectingPlatform(platform.id);

    try {
      // Prepare credential data
      const credentialData = {
        platform: platform.id,
        account_name: `${client.client_name}'s ${platform.name}`,
        client_id: client.id,
        ...platformData  // Spread all field values
      };

      // Verify credential first
      const verifyResult = await credentialsAPI.verifyCredential(credentialData, token);

      if (!verifyResult.success) {
        alert('❌ ' + verifyResult.message);
        setConnectingPlatform(null);
        return;
      }

      // Add credential
      const addResult = await credentialsAPI.addCredential(credentialData, token);

      if (addResult.success) {
        alert('✅ ' + verifyResult.message + ' for ' + client.client_name);
        setFormData(prev => ({
          ...prev,
          [platform.id]: {}
        }));
        fetchCredentials();
      }

    } catch (err) {
      console.error('Connection error:', err);
      alert('Error: ' + (err.message || 'Failed to connect'));
    } finally {
      setConnectingPlatform(null);
    }
  };

  const handleDisconnect = async (platform) => {
    if (!window.confirm(`Disconnect ${platform.name} for ${client.client_name}?`)) {
      return;
    }

    try {
      const credential = getCredential(platform.id);
      if (credential) {
        const result = await credentialsAPI.deleteCredential(credential.id, token);
        if (result.success) {
          alert(`${platform.name} disconnected successfully`);
          fetchCredentials();
        }
      }
    } catch (err) {
      console.error('Disconnect error:', err);
      alert('Error: ' + (err.message || 'Failed to disconnect'));
    }
  };

  // ✅ ADD THIS ENTIRE FUNCTION HERE (after handleDisconnect)
  // ✅ NEW: Automatic YouTube OAuth for Clients
  const handleYouTubeAuthorizeAuto = async (platform) => {
    setConnectingPlatform(platform.id);

    try {
      console.log('🚀 Starting automatic YouTube OAuth for client:', client.client_name);

      // Step 1: Get OAuth URL from backend
      const response = await axios.post(
        `${API_BASE_URL}/api/oauth-auto/youtube/start`,  // Or use API_BASE_URL
        { 
          client_id: client.id  // ✅ Pass client ID for organization
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (!response.data.success) {
        alert('Failed to start YouTube authorization');
        setConnectingPlatform(null);
        return;
      }

      console.log('✅ OAuth URL received, opening popup...');

      // Step 2: Open popup window
      const width = 600;
      const height = 700;
      const left = (window.screen.width / 2) - (width / 2);
      const top = (window.screen.height / 2) - (height / 2);

      const popup = window.open(
        response.data.authUrl,
        'YouTube Authorization',
        `width=${width},height=${height},left=${left},top=${top}`
      );

      if (!popup) {
        alert('Popup blocked! Please allow popups for this site.');
        setConnectingPlatform(null);
        return;
      }

      // Step 3: Listen for messages from popup
      const messageHandler = (event) => {
        if (event.data.type === 'youtube-oauth-success') {
          console.log('✅ YouTube connected:', event.data.channelTitle);
          
          window.removeEventListener('message', messageHandler);
          setConnectingPlatform(null);
          
          alert(`✅ Successfully connected ${event.data.channelTitle} for ${client.client_name}`);
          fetchCredentials(); // Refresh the list
          
        } else if (event.data.type === 'youtube-oauth-error') {
          console.error('❌ OAuth error:', event.data.error);
          
          window.removeEventListener('message', messageHandler);
          setConnectingPlatform(null);
          
          alert(`❌ Connection failed: ${event.data.error}`);
        }
      };

      window.addEventListener('message', messageHandler);

      // Monitor if popup is closed
      const checkPopup = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkPopup);
          window.removeEventListener('message', messageHandler);
          setConnectingPlatform(null);
        }
      }, 1000);

    } catch (error) {
      console.error('❌ Error:', error);
      alert('Failed to start authorization: ' + error.message);
      setConnectingPlatform(null);
    }
  };

  // ✅ NEW: Automatic LinkedIn OAuth for Clients
  const handleLinkedInAuthorizeAuto = async (platform) => {
    setConnectingPlatform(platform.id);

    try {
      console.log('🚀 Starting automatic LinkedIn OAuth for client:', client.client_name);

      // Step 1: Get OAuth URL from backend
      const response = await axios.post(
        `${API_BASE_URL}/api/oauth-auto/linkedin/start`,
        { 
          client_id: client.id  // ✅ Pass client ID for organization
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (!response.data.success) {
        alert('Failed to start LinkedIn authorization');
        setConnectingPlatform(null);
        return;
      }

      console.log('✅ OAuth URL received, opening popup...');

      // Step 2: Open popup window
      const width = 600;
      const height = 700;
      const left = (window.screen.width / 2) - (width / 2);
      const top = (window.screen.height / 2) - (height / 2);

      const popup = window.open(
        response.data.authUrl,
        'LinkedIn Authorization',
        `width=${width},height=${height},left=${left},top=${top}`
      );

      if (!popup) {
        alert('Popup blocked! Please allow popups for this site.');
        setConnectingPlatform(null);
        return;
      }

      // Step 3: Listen for messages from popup
      const messageHandler = (event) => {
        if (event.data.type === 'linkedin-oauth-success') {
          console.log('✅ LinkedIn connected:', event.data);
          
          window.removeEventListener('message', messageHandler);
          setConnectingPlatform(null);
          
          alert(`✅ Successfully connected LinkedIn for ${client.client_name}`);
          fetchCredentials(); // Refresh the list
          
        } else if (event.data.type === 'linkedin-oauth-error') {
          console.error('❌ OAuth error:', event.data.error);
          
          window.removeEventListener('message', messageHandler);
          setConnectingPlatform(null);
          
          alert(`❌ Connection failed: ${event.data.error}`);
        }
      };

      window.addEventListener('message', messageHandler);

      // Monitor if popup is closed
      const checkPopup = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkPopup);
          window.removeEventListener('message', messageHandler);
          setConnectingPlatform(null);
        }
      }, 1000);

    } catch (error) {
      console.error('❌ Error:', error);
      alert('Failed to start authorization: ' + error.message);
      setConnectingPlatform(null);
    }
  };

  if (loading) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div style={{ padding: '40px', textAlign: 'center' }}>Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="client-creds-overlay" onClick={onClose}>
      <div className="client-creds-modal" onClick={(e) => e.stopPropagation()}>
        <div className="client-creds-header">
          <div>
            <h2>Connect Accounts for {client.client_name}</h2>
            <p>Link social media platforms for this client</p>
          </div>
          <button className="client-creds-close" onClick={onClose}>✕</button>
        </div>

        <div className="client-creds-body">
          <div className="platforms-grid-modal">
            {platforms.map(platform => {
              const connected = isConnected(platform.id);
              const credential = getCredential(platform.id);

              return (
                <div 
                  key={platform.id} 
                  className={`platform-card-modal ${connected ? 'connected' : ''}`}
                >
                  <div className="platform-header-modal">
                    <span className="platform-icon-modal">{platform.icon}</span>
                    <h3>{platform.name}</h3>
                    {connected && <span className="connected-badge-modal">✓ Connected</span>}
                  </div>

                  {connected ? (
                    <div className="connected-info-modal">
                      <p className="account-name-modal">{credential?.account_name}</p>
                      <button 
                        className="btn-disconnect-modal"
                        onClick={() => handleDisconnect(platform)}
                      >
                        Disconnect
                      </button>
                    </div>
                  ) : (
                    <div className="connect-form-modal">
                      {platform.fields.map(field => (
                        <input
                          key={field.name}
                          type={field.type || "text"}  // ✅ CHANGE: Use field.type
                          placeholder={field.placeholder}
                          value={formData[platform.id]?.[field.name] || ''}
                          onChange={(e) => handleInputChange(platform.id, field.name, e.target.value)}
                          className="credential-input-modal"
                        />
                      ))}
                      <button 
                        className="btn-connect"
                        onClick={() => {
                          if (platform.type === 'oauth_auto') {
                            if (platform.id === 'youtube') {
                              handleYouTubeAuthorizeAuto(platform);
                            } else if (platform.id === 'facebook') {
                              handleFacebookAuthorizeAuto(platform);  // ✅ New name
                            }else if (platform.id === 'linkedin') {  // ✅ ADD THIS
                              handleLinkedInAuthorizeAuto(platform);
                            }
                          } else {
                            handleConnect(platform);
                          }
                        }}
                        disabled={connectingPlatform === platform.id}
                      >
                        {connectingPlatform === platform.id ? 'Connecting...' : 'Connect'}
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientCredentialsModal;